import React, {
    Fragment
} from 'react';
import {
    Dialog,
    Transition
} from '@headlessui/react';

import PropTypes from 'prop-types';


RIQModal.propTypes = {
    children: PropTypes.node,
    onModalDismissed: PropTypes.func,
    showModal: PropTypes.bool,
    title: PropTypes.node,
    variant: PropTypes.string
};

export default function RIQModal({children, initialFocus = null, onModalDismissed, overflow, showModal, title, variant = 'large'}) {

    let variantClassName;
    switch (variant) {
        case 'small':
            variantClassName = 'tlw-w-300 tlw-m-5';
            break;
        case 'large':
            variantClassName = 'tlw-m-5 sm_tlw-w-300 md_tlw-w-450';
            break;
        default:
            throw new Error(`Unknown button variant: ${variant}`);
    }

    const overflowClassName = `tlw-overflow-${overflow || 'hidden'}`;

    return (
        <Transition
            show={showModal || false}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
            as={Fragment}>
            <Dialog
                as='div'
                className='tlw-fixed tlw-inset-0 tlw-z-[1060]'
                initialFocus={initialFocus}
                onClose={() => onModalDismissed && onModalDismissed()}>
                <div className='tlw-fixed tlw-inset-0 tlw-z-10 tlw-bg-black tlw-bg-opacity-50' />

                <div className='tlw-fixed tlw-inset-0 tlw-z-20 tlw-overflow-y-auto'>
                    <div className='tlw-flex tlw-justify-center tlw-text-center'>
                        <Dialog.Panel className={`tlw-transform ${overflowClassName} tlw-rounded-md tlw-bg-white tlw-text-left tlw-shadow-xl tlw-transition-all sm_tlw-mx-auto sm_tlw-my-15 ${variantClassName}`}>
                            { title && (
                                <Dialog.Title
                                    as='div'
                                    className='tlw-flex tlw-justify-between tlw-border-0 tlw-border-b tlw-border-solid tlw-border-gray-300 tlw-p-7.5 tlw-text-lg tlw-font-medium tlw-leading-6 tlw-text-gray-900 '
                                >
                                    {title}
                                    {onModalDismissed &&
                                        <div>
                                            <button
                                                type='button'
                                                className='tlw-justify-center tlw-border-0 tlw-bg-transparent tlw-p-0 tlw-text-[2.1rem] tlw-font-bold tlw-text-black tlw-opacity-20 hover_tlw-cursor-pointer hover_tlw-opacity-50'
                                                onClick={() => onModalDismissed()}
                                            >
                                            &times;
                                            </button>
                                        </div>
                                    }
                                </Dialog.Title>
                            )}
                            <div>
                                {children}
                            </div>
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
